import axios from "axios";
import {
  generatePreSignedUrl,
  generatePreSignedUrlWithoutToken,
} from "../services/awsServices";
import dayjs from "./myDayjs";

export const getTime = (date) => {
  date = new Date(date);

  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert hours to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // 12 should be displayed as 12, not 0

  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes} ${ampm}`;
};

export const uploadDocFun = async (fileList) => {
  console.log({ fileList });
  const splitName = fileList[0].name?.split(".");
  const extension = "." + splitName[splitName.length - 1];
  const fileName = generateRandomNumber() + extension;
  console.log(fileName, "==fileName:uploadDocFun");
  const response = await generatePreSignedUrl({ keys: [fileName] });
  console.log(response.data, "==presignedUrllllll:uploadDocFun");
  await axios.put(response.data.presignedUrl[0], fileList[0].originFileObj, {
    headers: { "Content-Type": "binary/octet-stream" },
  });
  return fileName;
};
export const uploadImageArray = async (imagesArray) => {
  console.log({ imagesArray });
  const imageNames = imagesArray.map((val) => {
    // const splitName = val?.name?.split(".");

    const fileName = generateRandomNumber() + "-" + val.name;
    return fileName;
  });
  console.log({ imageNames });
  const response = await generatePreSignedUrl({ keys: imageNames });
  for (let i = 0; i < imageNames.length; i++) {
    const url = response.data.presignedUrl[i];
    await axios.put(url, imagesArray[i].originFileObj, {
      headers: { "Content-Type": "binary/octet-stream" },
    });
  }

  return imageNames;
  // const extension = splitName.map(val => "." + val);
  // const fileName = generateRandomNumber() + extension;
  // console.log(fileName, "==fileName:uploadDocFun");
  // const response = await generatePreSignedUrl({ keys: [fileName] });
  // console.log(response.data, "==presignedUrllllll:uploadDocFun");
  // await axios.put(response.data.presignedUrl[0], fileList[0].originFileObj, {
  //   headers: { "Content-Type": "binary/octet-stream" },
  // });
  // return fileName;
};
export const uploadDocFunWithoutToken = async (fileList) => {
  const splitName = fileList[0].name?.split(".");
  const extension = "." + splitName[splitName.length - 1];
  const fileName = generateRandomNumber() + extension;
  console.log(fileName, "==fileName:uploadDocFun");
  const response = await generatePreSignedUrlWithoutToken({
    keys: [`${fileName}`],
  });
  console.log(response.data, "==presignedUrllllll:uploadDocFun");
  await axios.put(response.data.presignedUrl[0], fileList[0].originFileObj, {
    headers: { "Content-Type": "binary/octet-stream" },
  });
  return fileName;
};

export const uploadFilesToS3 = async (fileList = []) => {
  if (!Array.isArray(fileList)) return false;
  const promises = [];
  const fileNames = [];
  for (let i = 0; i < fileList.length; i++) {
    const element = fileList[i];
    const splitName = element.name?.split(".");
    const extension = "." + splitName[splitName.length - 1];
    const fileName = generateRandomNumber() + extension;
    fileNames.push(fileName);
  }
  const response = await generatePreSignedUrl({ keys: fileNames });
  console.log(response.data, "==presignedUrllllll:uploadDocFun");

  const headers = { "Content-Type": "binary/octet-stream" };

  for (let j = 0; j < fileList.length; j++) {
    const file = fileList[j];
    promises.push(
      axios.put(response.data.presignedUrl[j], file.originFileObj, { headers })
    );
  }

  await Promise.all(promises);
  return fileNames;
};

export function truncateText(text = "", maxLength) {
  if (text?.length > maxLength) {
    return text.slice(0, maxLength) + "...";
  }
  return text;
}

export function generateRandomNumber() {
  return (
    Date.now().toString(36) +
    "-" +
    Math.ceil(Math.random() * 1000000 + 1000000) +
    "-" +
    Math.ceil(Math.random() * 10000000 + 10000000) +
    "-" +
    Math.ceil(Math.random() * 8000000 + 8000000)
  );
}

// if only year then show correct date
export function formatDateForAchivement(input) {
  let resultDate;

  // Check if input is only a year (assuming a valid year is between 1000 and 9999)
  if (/^\d{4}$/.test(input)) {
    // If only a year is provided, format it as 01/01/YYYY
    resultDate = dayjs(`01-01-${input}`).format("MM/DD/YYYY");
  } else {
    // Try to parse the input with dayjs
    const date = dayjs(input);

    // If the date is valid, format it; otherwise, use today's date
    resultDate = date.isValid()
      ? date.format("MM/DD/YYYY")
      : dayjs().format("MM/DD/YYYY");
  }

  return resultDate;
}
